import React from 'react'
import { Outlet } from 'react-router-dom'
import useBreakpoint from 'hooks/useBreakpoint'
import SideBar from './SideBar'
import * as S from './styles'

const Layout = () => {
  const isBigScreen = useBreakpoint()

  return (
    <S.Page isBigScreen={isBigScreen}>
      {isBigScreen && <SideBar />}
      <div className='max-w-[100vw] p-2 sm:p-6'>
        <Outlet />
      </div>
    </S.Page>
  )
}

export default Layout
